import { render, staticRenderFns } from "./udid.vue?vue&type=template&id=a7239c64&scoped=true"
import script from "./udid.vue?vue&type=script&lang=js"
export * from "./udid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7239c64",
  null
  
)

export default component.exports